import React, {useEffect} from 'react';
import analytics from '@react-native-firebase/analytics';
import {useNavigation, useRoute} from '@react-navigation/native';
import {SafeAreaView} from 'react-native-safe-area-context';

import {Header} from '../../../components/Interface/Headers/Header';
import {Button} from '../../../components/Interface/Forms/Buttons/Button';

import {
  Container,
  Content,
  IconWrapper,
  IconStyled,
  Title,
  Description,
  StepList,
  StepItem,
  StepNumber,
  StepNumberText,
  StepText,
  Footer,
} from './styles';
import {EmprestimoEligibilityGate} from '../../../components/shared/EmprestimoEligibilityGate';

type RouteParams = {
  simulacao: any;
  installments_option_id: string;
  selectedOption: any;
  endereco_id: string;
  domicilio_id: string;
};

export function DocumentosIntro() {
  const navigation = useNavigation();
  const route = useRoute();
  const params = route.params as RouteParams;

  useEffect(() => {
  analytics().logEvent('emprestimo_tela_documentos_intro');
}, []);

 const handleContinue = () => {
  analytics().logEvent('emprestimo_clicou_comecar_documentos');
  (navigation as any).navigate('EmprestimoTipoDocumento', {
    ...params,
  });
};

  return (
    <SafeAreaView edges={['bottom']} style={{flex: 1}}>
      <EmprestimoEligibilityGate />
      <Header icon="chevron-left" />

      <Container>
        <Content>
          <IconWrapper>
            <IconStyled name="camera" />
          </IconWrapper>

          <Title>Verificação de identidade</Title>

          <Description>
            Para sua segurança, precisamos verificar sua identidade. Você vai
            tirar fotos do seu documento e uma selfie. Não se preocupe, é rápido!
          </Description>

          <StepList>
            <StepItem>
              <StepNumber>
                <StepNumberText>1</StepNumberText>
              </StepNumber>
              <StepText>Foto da frente do documento (RG ou CNH)</StepText>
            </StepItem>

            <StepItem>
              <StepNumber>
                <StepNumberText>2</StepNumberText>
              </StepNumber>
              <StepText>Foto do verso do documento</StepText>
            </StepItem>

            <StepItem>
              <StepNumber>
                <StepNumberText>3</StepNumberText>
              </StepNumber>
              <StepText>Selfie do seu rosto para validação</StepText>
            </StepItem>
          </StepList>
        </Content>

        <Footer>
          <Button title="Começar" onPress={handleContinue} enabled />
        </Footer>
      </Container>
    </SafeAreaView>
  );
}
